import { SelectOption } from 'components/ui/select'

export const ONBOARDING_ROLE_OPTIONS: SelectOption[] = [
  {
    id: 1,
    value: 'Business Owner',
    name: 'onboarding_questionnaire_selection_owner',
  },
  {
    id: 2,
    value: 'Marketing Freelancer',
    name: 'onboarding_questionnaire_selection_freelancer',
  },
  {
    id: 3,
    value: 'Marketing Agency Employee',
    name: 'onboarding_questionnaire_selection_agency_employee',
  },
  {
    id: 4,
    value: 'Small Business Employee',
    name: 'onboarding_questionnaire_selection_small_business_employee',
  },
  {
    id: 5,
    value: 'Enterprise Employee',
    name: 'onboarding_questionnaire_selection_enterprise_employee',
  },
]
